import React from "react";
import "./ApplicationProcess.css";

const steps = [
  {
    step: "STEP 01",
    title: "Register",
    desc: "Create your applicant profile and begin the application process.",
  },
  {
    step: "STEP 02",
    title: "Submit",
    desc: "Complete the application form and upload the required documents.",
  },
  {
    step: "STEP 03",
    title: "Interaction",
    desc: "Attend a scheduled interaction session with the child and parents.",
  },
  {
    step: "STEP 04",
    title: "Confirmation",
    desc: "Receive admission confirmation and onboarding instructions",
  },
];

const ApplicationProcess = () => {
  return (
    <section className="application-process">
      <div className="landing-pages">
        <p className="founder-subtitle">— The Roadmap</p>

        <h2 className="founder-title">
          Application <span>Process</span>
        </h2>

        <div className="process-grid">
          {steps.map((item, index) => (
            <div className="process-card" key={index}>
              <div className="step-line">
                <span>{item.step}</span>
                <div className="line"></div>
              </div>

              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApplicationProcess;
